import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import moment from 'moment';
import Popover from '@/components/popover_component.vue';
import LoaderPopover from '@/components/loaderpopover_component.vue';
export default {
    name: 'mobileviewbooking',
    components: {
        Multiselect,
        Popover,
        LoaderPopover
    },
    data() {
        return {   
            present_status: '',
            book_present_status: '',
            more_content : false,
            more_content_booking_note:false,
            book_start_date:'',
            services_data : [],
            status : [
                {'status_id' : this.Constants.STATUS_BOOKED , 'status_name' : 'Booked', 'img' :'booked_icon.svg','color_class' : 'light_blue' },
                {'status_id' : this.Constants.STATUS_ARRIVED , 'status_name' : 'Arrived', 'img' :'arrived_icon.svg', 'color_class' : 'blue' },
                {'status_id' : this.Constants.STATUS_COMPLETED , 'status_name' : 'Completed', 'img' :'completed_icon.svg', 'color_class' : 'green' },
                {'status_id' : this.Constants.STATUS_EARLY_CANCELLED , 'status_name' : 'Cancelled', 'img' :'cancel_icon.svg','color_class' : 'text-danger' },
                {'status_id' : this.Constants.STATUS_LATE_CANCELLED , 'status_name' : 'Late Cancelled', 'img' :'late_cancel_icon.svg','color_class' : 'text-danger' },
                {'status_id' : this.Constants.STATUS_NO_SHOW , 'status_name' : 'No-show', 'img' :'noshow_icon.svg', 'color_class' : 'orange' },
            ],
        }
        
    },
    computed: {
        ...mapGetters(["get_bookings_and_amount_data_v2","get_services","get_customers","get_booking_images"])
    },  
    async  mounted ()
    {  
        this.window_scroll_to_top();
        this.$store.state.loader_popup = true;
        await this.$store.dispatch('get_booking_and_amount_details_v2',[this.$store.state.api,this.$session.get('book_id'),this.$session.get('multi_book_id')])

        this.services_data = this.$store.state.bookings_data_v2.bookings;
        if ((this.$store.state.bookings_data_v2.bookings).length >0){
            await this.$store.dispatch('get_customer_details',[this.$store.state.api,[this.services_data[0].cust_id, this.services_data[0].owner_id]])
            await this.$store.dispatch('get_customer_images',[this.$store.state.api,[this.services_data[0].cust_id,this.$session.get('book_id'),this.$session.get('book_id'),this.$session.get('multi_book_id')]])
            await this.$store.dispatch('get_booking_log',[this.$store.state.api,this.$session.get('book_id'),this.$session.get('book_id'),this.$session.get('multi_book_id')]) 
        }
       

        // if(this.services_data.length){
        //     this.$store.state.book_status = this.present_status =  this.services_data[0].book_status;  
        // }

        if(!this.services_data.every(serv_array => serv_array.book_status == this.Constants.STATUS_EARLY_CANCELLED)){
            this.services_data.forEach( (serv_array, serv_index) => {
                if(serv_array.book_status == this.Constants.STATUS_EARLY_CANCELLED){
                    this.services_data.splice(serv_index,1);
                }
            })
        }


        if(this.services_data.length){
            this.$session.set('store_id',this.$store.state.bookings_data_v2.bookings[0].store_id);
            this.$store.state.book_status = this.present_status = this.$store.state.bookings_data_v2.bookings[0].book_status;
            this.book_start_date = moment(this.$store.state.bookings_data_v2.bookings[0].book_start_date).format('YYYY-MM-DD');
        }

        await this.status_apply();
        this.$store.state.loader_popup = false;

    },
    methods:{
        window_scroll_to_top(){window.scrollTo(0,0)},
        status_change(selected){

            if(selected == this.Constants.STATUS_BOOKED){
                this.$store.state.booked_popup = true;
            }
            else if(selected == this.Constants.STATUS_ARRIVED){
                this.$store.state.arrived_popup = true;
            }
            else if(selected == this.Constants.STATUS_COMPLETED){
                this.$store.state.completed_popup = true;
            }
            else if(selected == this.Constants.STATUS_NO_SHOW){
                this.$store.state.noshow_popup = true;
            }
            else if(selected == this.Constants.STATUS_EARLY_CANCELLED){
                this.$store.state.cancel_popup = true;
            }
            else if(selected == this.Constants.STATUS_LATE_CANCELLED){
                this.$store.state.latecancel_popup = true;
            }
        },
        changeValue(type){

            if(type == this.Constants.STATUS_BOOKED){
                this.$store.state.book_status = this.present_status
                this.$store.state.booked_popup = false;
            }
            else if(type == this.Constants.STATUS_ARRIVED){
                this.$store.state.book_status = this.present_status
                this.$store.state.arrived_popup = false;
            }
            else if(type == this.Constants.STATUS_COMPLETED){
                this.$store.state.book_status = this.present_status
                this.$store.state.completed_popup = false;
            }
            else if(type == this.Constants.STATUS_NO_SHOW){
                this.$store.state.book_status = this.present_status
                this.$store.state.noshow_popup = false;
            }
            else if(type == this.Constants.STATUS_EARLY_CANCELLED){
                this.$store.state.book_status = this.present_status
                this.$store.state.cancel_popup = false;
            }
            else if(type == this.Constants.STATUS_LATE_CANCELLED){
                this.$store.state.book_status = this.present_status
                this.$store.state.latecancel_popup = false;
            }
        },
        cancelStatusChange(type){
            if(type == this.Constants.STATUS_BOOKED){
                this.present_status = this.$store.state.book_status;
                this.$store.state.booked_popup = false;
            }
            else if(type == this.Constants.STATUS_ARRIVED){
                this.present_status = this.$store.state.book_status;
                this.$store.state.arrived_popup = false;
            }
            else if(type == this.Constants.STATUS_COMPLETED){
                this.present_status = this.$store.state.book_status;
                this.$store.state.completed_popup = false;
            }
            else if(type == this.Constants.STATUS_NO_SHOW){
                this.present_status = this.$store.state.book_status;
                this.$store.state.noshow_popup = false;
            }
            else if(type == this.Constants.STATUS_EARLY_CANCELLED){
                this.present_status = this.$store.state.book_status;
                this.$store.state.cancel_popup = false;
            }
            else if(type == this.Constants.STATUS_LATE_CANCELLED){
                this.present_status = this.$store.state.book_status;
                this.$store.state.latecancel_popup = false;
            }

            this.status_apply();
        },

        status_apply(){
            for(let j=0; j < this.status.length; j++)
            {   
                if(this.present_status == this.status[j].status_id){
                    this.book_present_status = this.status[j];
                }
            }
        },
        open_today_bookings()
        {
          this.$session.set('selected_booking_date',this.book_start_date);
          this.$router.push('/bookings')
        }

    },
    filters:{
        time_12hrs_format:function(time){
            return moment(time ,'hh:mm A').format('hh:mm A');
        },
        content_less: function(content){
            return content.substr(0, 100);
        },
        human_date_format: function (date) {
            return moment(date).format('MMM DD, YYYY');
        },


    }
}